




















































import Vue from 'vue';
import {RoutsData} from '@/router/routs';
import {VideoApi} from '@/api/video-api';
import {Video} from '@/types/video';
import {VideoChannel} from '@/types/video-channel';
import {VideoChannelApi} from '@/api/video-channel-api';

let videoId: string;
export default Vue.extend({
  name: 'Video',
  created() {
    videoId = this.$route.params.videoId;
    if (videoId) {
      VideoApi.getOne(videoId as string).then((res: any) => {
        this.video = res.data;
      });
    }

    VideoChannelApi.getList().then(res => this.videoChannels = res.data);
  },
  data() {
    return {
      video: new Video(this.$store.state.user.initiatorId),
      videoChannels: [] as VideoChannel[],
      load: false
    };
  },
  computed: {
    isSave(): boolean {
      return videoId != undefined;
    }
  },
  methods: {
    onSave() {
      VideoApi.save(this.video).then(res => {
        this.$store.commit('setMessage', {
          show: true,
          text: 'Изменения сохранены'
        });

        this.video = res.data;
        this.$router.push({name: RoutsData.VIDEO.name, params: {videoId: res.data.id.toString()}});
      });
    }
  }
});
